import {
  Paper,
  Stack,
  SxProps,
  Typography,
  TypographyProps,
} from "@mui/material"

export interface SectionProps {
  children?: React.ReactNode
  title?: string
  titleTypographyProps?: TypographyProps
  sx?: SxProps
  variant?: "outlined" | "elevation"
  elevation?: number
  spacing?: number
  actions?: React.ReactNode
  useFlexGap?: boolean
  disableGutters?: boolean
  square?: boolean
  containerSx?: SxProps
  subHeading?: string
  id?: string
}
export const Section = (props: SectionProps) => {
  const {
    children,
    sx,
    spacing = 2,
    variant,
    elevation = 0,
    title,
    titleTypographyProps,
    actions,
    useFlexGap,
    disableGutters = false,
    containerSx,
    subHeading,
    id,
  } = props
  // const { nbHits } = usePagination()
  return (
    <Paper
      component={Stack}
      spacing={spacing}
      elevation={elevation}
      variant={variant}
      useFlexGap={useFlexGap}
      square
      id={id}
      sx={{
        bgcolor: "background.default",
        ...sx,
      }}
    >
      {(title || actions) && (
        <Stack
          direction={{
            xs: "column",
            sm: "row",
          }}
          alignItems={{ xs: "flex-start", sm: "center" }}
          justifyContent="space-between"
          sx={{
            px: {
              xs: 2,
              sm: 3,
              md: 4,
            },
          }}
          gap={1}
        >
          <Stack>
            {title && (
              <Stack flexGrow={1}>
                <Typography variant="h2" {...titleTypographyProps}>
                  {title}
                </Typography>
              </Stack>
            )}
            {subHeading && (
              <Stack flexGrow={1}>
                <Typography color="#766F62" variant="h5">
                  {subHeading}
                </Typography>
              </Stack>
            )}
          </Stack>
          {actions && (
            <Stack
              direction="row"
              alignItems="center"
              sx={{ width: { xs: "100%", sm: "auto" } }}
            >
              {actions}
            </Stack>
          )}
        </Stack>
      )}
      <Stack
        sx={{
          px: disableGutters
            ? 0
            : {
                xs: 2,
                sm: 3,
                md: 4,
              },
          ...containerSx,
        }}
      >
        {children}
      </Stack>
    </Paper>
  )
}
